"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = exports.parentAccountHostedZoneId = exports.parentAcccountId = exports.parentHostedZoneName = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const groupDefinitions_1 = require("./Cognito/groupDefinitions");
const userInvites_1 = require("./Cognito/userInvites");
const overrides_1 = require("./Lambda/overrides");
const Ruleset_1 = require("./Ruleset");
const S3_1 = require("./S3");
const v020DefaultEnvironmentSettings_1 = require("./v020DefaultEnvironmentSettings");
const debug = process.env.REACT_APP_DEBUG === 'true' && false;
exports.parentHostedZoneName = 'iotv.link';
exports.parentAcccountId = '252855055641';
exports.parentAccountHostedZoneId = 'Z037408026LR1VED1RWZN';
const TLD = exports.parentHostedZoneName;
const mailFromSubDomain = 'mail';
const mailFromAccountName = 'support'; // info
const { projectCode, AWS_DEFAULT_REGION, REACT_APP_PROJECT_CODE, REACT_APP_DEPLOYMENT_STAGE, stage = REACT_APP_DEPLOYMENT_STAGE, REACT_APP_AWS_DEFAULT_REGION, } = process.env;
const shortProjectCode = (_a = (projectCode !== null && projectCode !== void 0 ? projectCode : REACT_APP_PROJECT_CODE)) === null || _a === void 0 ? void 0 : _a.substring(0, 4);
const getInternalAccountDomain = () => `${stage !== null && stage !== void 0 ? stage : REACT_APP_DEPLOYMENT_STAGE}.${shortProjectCode}.${TLD}`;
/** used for example in s3 CORS configuration */
const getUIUrls = () => [
//`https://app.${getInternalAccountDomain()}`,
// `https://*.${getInternalAccountDomain()}`,
];
exports.config = {
    entityReadings: 'S3_ATHENA_GLUE',
    google: {
        gcp: {
            clientId: '903446274831-lshl3denji3m3qpc3fg74r015mlapd5u.apps.googleusercontent.com',
            apiKey: 'AIzaSyCVQdK7-DIokXhFlNbpcwan0_RE4iX1Zos',
        },
    },
    ventureTypeExtensions: {
        Area: {
            subtype: ['Paddock', 'ExclusionZone', 'Effluent', 'SoilMoisture', 'IrrigationArea', 'SoilType', 'Coverage'],
        },
    },
    weather: {
        openWeather: {
            apiKey: 'e489737747db3e59e835aeaee9cd1180',
        },
    },
    domain: stage === 'prod' ? 'watertogrow.com' : undefined,
    parentAccountDomain: undefined,
    internalAccountDomain: getInternalAccountDomain(),
    mailFromSubDomain,
    mailFromAccountName,
    uiUrls: getUIUrls(),
    apiConfigs: [
        {
            name: 'V020Api',
            endpoint: `https://control.${REACT_APP_DEPLOYMENT_STAGE}.v020.iotv.link`,
            region: (_b = AWS_DEFAULT_REGION !== null && AWS_DEFAULT_REGION !== void 0 ? AWS_DEFAULT_REGION : REACT_APP_AWS_DEFAULT_REGION) !== null && _b !== void 0 ? _b : 'never',
        },
    ],
    aws: {
        environments: {
            ...v020DefaultEnvironmentSettings_1.defaultEnvironmentSettings,
        },
        ApiGateway: {
            ConsumerAPI: { enableVpcAndIPv6: false }, // dont use redis, yet
        },
        Cognito: { groupDefinitions: groupDefinitions_1.groupDefinitions, userInvitationConfig: userInvites_1.userInvitationConfig },
        Lamdba: overrides_1.lambdaOverrides,
        S3: { UIBuckets: S3_1.uiBucketDef },
        ECS: {
            Redis: {
                computeService: 'FARGATE',
                options: {
                    scalingLimits: null,
                    sizing: stage === 'prod' ? { cpu: 2048, memoryLimitMiB: 16384 } : stage === 'test' ? { cpu: 256, memoryLimitMiB: 512 } : { cpu: 256, memoryLimitMiB: 512 },
                },
            },
            FanOut: stage === 'prod' || stage === 'test' ? {
                // NO SCALING
                computeService: 'FARGATE',
                options: {
                    scalingLimits: null,
                    sizing: stage === 'prod'
                        ? { cpu: 256, memoryLimitMiB: 1024 }
                        : stage === 'test'
                            ? { cpu: 256, memoryLimitMiB: 512 } // test ok
                            : { cpu: 256, memoryLimitMiB: 512 },
                },
            } : { computeService: 'LAMBDA' },
            NetworkData: stage === 'prod' || stage === 'test' ? {
                computeService: 'FARGATE',
                options: {
                    scalingLimits: {
                        minCapacity: 2,
                        maxCapacity: 5,
                    },
                    capacityProviderStrategies: [
                        {
                            capacityProvider: 'FARGATE_SPOT',
                            weight: 1,
                        },
                        // {
                        //   capacityProvider: 'FARGATE',
                        //   weight: 0, // Optional: fallback to regular Fargate if desired
                        // }
                    ],
                    sizing: stage === 'prod'
                        ? { cpu: 256, memoryLimitMiB: 512 }
                        : stage === 'test'
                            ? { cpu: 256, memoryLimitMiB: 512 } // test ok
                            : { cpu: 256, memoryLimitMiB: 512 },
                },
            } : { computeService: 'LAMBDA' },
            Wideawake: {
                computeService: 'FARGATE',
                options: {
                    scalingLimits: null,
                    sizing: stage === 'prod'
                        ? { cpu: 512, memoryLimitMiB: 1024 }
                        : stage === 'test'
                            ? { cpu: 256, memoryLimitMiB: 512 } // test ok
                            : { cpu: 256, memoryLimitMiB: 512 },
                },
            },
            EntityState: stage === 'prod' || stage === 'test' ? {
                computeService: 'FARGATE',
                options: {
                    scalingLimits: {
                        minCapacity: 4, // Baseline for steady traffic
                        maxCapacity: 8,
                    },
                    capacityProviderStrategies: [
                        {
                            capacityProvider: 'FARGATE',
                            base: 2,
                            weight: 1,
                        },
                        {
                            capacityProvider: 'FARGATE_SPOT',
                            weight: 3,
                        },
                    ],
                    sizing: stage === 'prod' ? { cpu: 1024, memoryLimitMiB: 2048 } : stage === 'test' ? { cpu: 512, memoryLimitMiB: 2048 } : { cpu: 256, memoryLimitMiB: 512 },
                },
            } : { computeService: 'LAMBDA' },
        },
    },
    apps: {
        webUI: {
            deviceMap: {
                [iotv_v3_types_1.DeviceTypes.AgriTel]: { name: 'Pressure Sensor' },
                [iotv_v3_types_1.DeviceTypes.AngleTel]: { name: 'AngelTel' },
                [iotv_v3_types_1.DeviceTypes.EffluentTracker]: { name: 'Effluent Tracker' },
                [iotv_v3_types_1.DeviceTypes.ElsysSensor]: { name: 'ElsysSensor' },
                [iotv_v3_types_1.DeviceTypes.GenericSensor]: { name: 'GenericSensor' },
                [iotv_v3_types_1.DeviceTypes.HiveSafe]: { name: 'HiveSafe' },
                [iotv_v3_types_1.DeviceTypes.IsolationValve]: { name: 'Extended Valve' },
                [iotv_v3_types_1.DeviceTypes.PowerAct]: { name: 'Pump Controller' },
                [iotv_v3_types_1.DeviceTypes.RangeTel]: { name: 'Range Detector' },
                [iotv_v3_types_1.DeviceTypes.RoveTel]: { name: 'RoveTel' },
                [iotv_v3_types_1.DeviceTypes.SenseTel]: { name: 'SenseTel' },
                [iotv_v3_types_1.DeviceTypes.SoilMoisture]: { name: 'Soil Moisture' },
                [iotv_v3_types_1.DeviceTypes.TakeFlowMeter]: { name: 'Flow Meter' },
                [iotv_v3_types_1.DeviceTypes.ThirdParty]: { name: 'Third Party' },
                [iotv_v3_types_1.DeviceTypes.ValveAct]: { name: 'Irrigator Controller' },
                [iotv_v3_types_1.DeviceTypes.VesselSensor]: { name: 'Vessel Sensor' },
                [iotv_v3_types_1.DeviceTypes.VibeTel]: { name: 'Vibration Monitor' },
            },
            pruneEntityNetworks: false,
            ventureName: 'Water To Grow',
            initialRedirect: 'HOMEPAGE',
            useSpecializedViews: true,
            supportEmail: 'support@watertogrow.com',
            pruneGenericEntities: true,
        },
    },
    iotv: {
        'device-control-arbitration': {
            allowDownlinkDuplication: true,
        },
        // "system-provisioning": {
        //     useDeprecatedCustomerHierachy: true, // for v020 this should be predicated on test | prod
        // }
    },
    BaseData: Ruleset_1.rules,
};
